const u = (id) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=2400&q=80`;
const p = (id) => `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=2400`;

/** Rewrite the width parameter so we never ship a 2400px image into a 400px tile. */
export const sized = (url, w) => (url ? url.replace(/([?&])w=\d+/, `$1w=${w}`) : url);

/* Every image is visually verified on a contact sheet: real industrial / electrical / Vestlandet photography. */
export const IMG = {
  // generated for this site: Norwegian homes, people and places (see tests/gen_images.py)
  home_hero: "/img/hero-home-xl.jpg",
  home_ev: "/img/hero-ev-xl.jpg",
  village: "/img/about-band-xl.jpg",
  svc_industri: "/img/svc-industri.jpg",
  svc_samferdsel: "/img/svc-samferdsel.jpg",
  svc_bygg: "/img/svc-bygg.jpg",
  svc_service: "/img/svc-service-xl.jpg",
  portrait_van: "/img/why-portrait-xl.jpg",
  // infrastructure
  tunnel: p(21790500),
  tunnel_road: p(31728249),
  substation: p(13820148),
  lineman: u("photo-1555963966-b7ae5404b6ed"),
  // industry
  smelter: u("photo-1474674556023-efef886fa147"),
  steel: u("photo-1496247749665-49cf5b1022e9"),
  automation_hall: p(36423820),
  control_room: u("photo-1714596282575-82d224db8c70"),
  control_desk: u("photo-1579719558505-ad4a5fee0847"),
  fish_farm: p(18511573),
  fish_farm_shore: p(9290793),
  // people at work
  electrician_woman: p(17843269),
  electrician_cabinet: p(17924298),
  electrician_kneel: p(39174676),
  electrician_pair: p(10871585),
  electrician_blue: p(21812146),
  technician_portrait: p(34054474),
  // detail
  breaker_panel: p(28950842),
  wiring: u("photo-1758101755915-462eddc23f57"),
  server_cables: u("photo-1558494949-ef010cbdcc31"),
  // building / home
  site_aerial: u("photo-1541888946425-d81bb19240f5"),
  ev_garage: p(34800930),
  ev_charger: p(27355835),
  ev_winter: u("photo-1652086509497-13c8be8ceb3f"),
  // landscape
  fjord_village: p(37046849),
  fjord_moody: p(6552181),
  fjord_aerial: p(33564870),
  aurland: p(35106808),
  hardanger_bridge: p(39734610),
};

export const NAV = [
  { to: "/industri", label: "Industri" },
  { to: "/samferdsel", label: "Samferdsel" },
  { to: "/bygg-naering", label: "Bygg og næring" },
  { to: "/service-bustad", label: "Service og bustad" },
  { to: "/prosjekt", label: "Prosjekt" },
  { to: "/prisar", label: "Prisar" },
  { to: "/om-oss", label: "Om oss" },
  { to: "/karriere", label: "Jobb hos oss" },
  { to: "/kontakt", label: "Kontakt" },
];

/* Official contact details from kvinnheradelektro.no/kontakt-oss */
export const COMPANY = {
  name: "Kvinnherad Elektro",
  legal: "Kvinnherad Elektro AS",
  phone: "53 48 28 00",
  phoneHref: "tel:+4753482800",
  email: "post@k-el.no",
  hq: { name: "Rosendal", role: "Hovudkontor", address: "Vangsvegen 13, Postboks 23, 5486 Rosendal", lines: ["Vangsvegen 13", "Postboks 23", "5486 Rosendal"], visit: ["Vangsvegen 13", "Rosendal"], post: ["Postboks 23", "5486 Rosendal"], short: "Vangsvegen 13, Rosendal" },
  branches: ["Husnes", "Halsnøy"],
  branchesText: "Husnes og Halsnøy",
  group: "Ein del av EQVA-konsernet sidan 2024",
  source: "kvinnheradelektro.no",
};

/* ---------- Front page copy ---------- */
export const HERO = {
  eyebrow: "Elektroentreprenør · Rosendal, Husnes og Halsnøy",
  title: "Elektro og automasjon. Frå sikringsskap til smelteverk.",
  lead: "Vi planlegg, installerer og held ved like elektriske anlegg i bustader, næringsbygg, industri og samferdsel på Vestlandet.",
  sub: "Kvinnherad Elektro har om lag 50 fagfolk, med hovudkontor i Rosendal og avdelingar på Husnes og Halsnøy.",
  primary: "Send førespurnad",
  secondary: "Sjå tenestene våre",
  alt: {
    home: "Elektrikar monterer ein heimeladar på eit kvitt trehus ved fjorden.",
    ev: "Kvinne koplar ladekabelen til ein elbil framfor eit raudt trehus.",
    village: "Trehus og kai ved fjorden, med fjell i bakgrunnen.",
    van: "Elektrikar med nettbrett ved ein open servicebil.",
    customers: "Ein elektrikar og to kundar ved eit ope sikringsskap.",
  },
};

/* The solid tile in the hero mosaic. */
export const HERO_TILE = {
  label: "Erfaring og nøkkeltal",
  title: "Meir enn 80 år i elektrofaget",
  text: "Vi har arbeidd med elektriske anlegg i Kvinnherad sidan 1940-talet. I dag tek vi oppdrag i lokale heimar og verksemder, og på større industri-, tunnel- og byggeprosjekt på Vestlandet.",
  facts: [
    ["80+ år", "i elektrobransjen"],
    ["Om lag 50", "tilsette"],
    ["3 avdelingar", "Rosendal, Husnes og Halsnøy"],
  ],
};

export const PULSE = {
  label: "Aktivitet i dag",
  updated: "Sist oppdatert kl.",
  montorar: "montørar på oppdrag i dag",
  orders: "aktive oppdrag",
  places: "Oppdragsstader:",
};

export const SERVICES_INTRO = {
  label: "Tenester",
  title: "Kva treng du hjelp med?",
  text: "Vi utfører service, installasjon og større entreprisar for private kundar, verksemder, entreprenørar og offentlege oppdragsgivarar.",
};

export const PATH_INDUSTRY = {
  label: "Industri, samferdsel og bygg",
  title: "Prosjekt, service og vedlikehald",
  paragraphs: [
    "Vi arbeider på industrianlegg, i tunnelar og på byggeplassar der arbeidet må planleggjast godt og gjennomførast i lag med andre fag.",
    "Oppdraga omfattar mellom anna nye installasjonar, ombyggingar, automasjon, vedlikehald og feilretting.",
    "Vi kan ta ansvar for heile leveransen eller gå inn som elektroentreprenør i større prosjekt.",
  ],
  links: ["industri", "samferdsel", "bygg-naering", "service-bustad"],
};

export const PATH_PRIVATE = {
  title: "Elektrikar i Kvinnherad",
  paragraphs: [
    "Vi tek serviceoppdrag i heimar, hytter og bedrifter i Kvinnherad.",
    "Det kan vere alt frå ein feil som må rettast, til ny heimeladar, sikringsskap, oppussing eller større elektriske arbeid.",
    "Send oss ei kort skildring av jobben, så tek vi kontakt.",
  ],
  pricesTitle: "Pris på vanlege oppdrag",
};

export const PRICES_INTRO = {
  label: "Prisar",
  title: "Priseksempel på vanlege jobbar",
  text: "Her finn du priseksempel på nokre av oppdraga vi ofte får spørsmål om. Endeleg pris avheng av omfanget og det eksisterande anlegget. Ved større arbeid avtaler vi synfaring før vi gir tilbod.",
  link: "Sjå alle prisar",
};

export const PROJECTS_INTRO = {
  label: "Prosjekt",
  title: "Utvalde prosjekt",
  text: "Vi har arbeidd med tunneloppgraderingar, industrianlegg og næringsbygg fleire stader på Vestlandet. Her er eit utval av prosjekta.",
  tile: "Les om prosjektet",
  link: "Sjå alle prosjekt",
};

export const ABOUT_HOME = {
  label: "Om Kvinnherad Elektro",
  title: "Eit elektrofirma med røter i Kvinnherad",
  paragraphs: [
    "Kvinnherad Elektro har vore ein del av lokalsamfunnet sidan 1940-talet. Vi har hovudkontor i Rosendal og avdelingar på Husnes og Halsnøy, og tek oppdrag i Kvinnherad og elles på Vestlandet.",
    "Arbeidet spenner frå service og installasjonar i private heimar til elektro og automasjon på store industri- og samferdselsprosjekt.",
    "Sidan 2024 har vi vore ein del av EQVA-konsernet.",
  ],
  links: [["/om-oss", "Les meir om oss"], ["/karriere", "Jobb hos oss"]],
};

export const PROCESS = {
  label: "Bestill elektrikar",
  title: "Dette skjer når du kontaktar oss",
  cta: "Send førespurnad",
  phoneLine: "Du kan òg ringje oss på",
};

export const MORE_WORK = {
  label: "Fleire prosjekt",
  title: "Utvalde referansar",
};

export const CONTACT_CTA = {
  label: "Kontakt",
  title: "Treng du elektrikar eller eit tilbod på eit prosjekt?",
  text: "Fortel oss kva du planlegg eller treng hjelp med. Vi tek imot førespurnader om både serviceoppdrag og større prosjekt.",
  sub: "",
  button: "Send førespurnad",
};

export const FOOTER_TAGLINE = "Elektro og automasjon til industri, samferdsel, næringsbygg og bustader på Vestlandet.";

/* Facts from kvinnheradelektro.no and EQVA ASA's announcement (2024). Nothing here is estimated. */
export const FACTS = [
  ["80+", "år i bransjen"],
  ["Om lag 50", "tilsette"],
  ["3", "avdelingar i Kvinnherad"],
  ["2024", "del av EQVA-konsernet"],
];

export const WHY_INTRO = {
  label: "Slik jobbar vi",
  title: "Service, prosjekt og kontroll",
};

export const WHY = [
  ["Erfarne serviceelektrikarar", "Våre faste serviceelektrikarar arbeider med feilretting, vedlikehald og mindre prosjekt. Servicebilane er utstyrte slik at vi kan løyse mest mogleg på første besøk."],
  ["Planlegging og gjennomføring", "Skal du byggje nytt, byggje om eller oppgradere eit anlegg, kan vi hjelpe med både prosjektering og installasjon. Vi følgjer arbeidet fram til anlegget er ferdig og dokumentert."],
  ["Kontroll av elektriske anlegg", "Vi utfører el-kontroll og periodiske kontrollar av elektriske anlegg, og hjelper verksemder med internkontroll."],
  ["Kapasitet til større oppdrag", "Gjennom Vassnes Solutions i Ølen og resten av EQVA-konsernet har vi tilgang på fleire fagfolk og eit større fagmiljø når oppdraga krev det."],
];

export const STEPS = [
  ["Fortel kva du treng hjelp med", "Send ei kort skildring av jobben og kvar arbeidet skal utførast. Legg gjerne ved bilete av anlegget eller området det gjeld."],
  ["Vi avklarer omfang og pris", "Vi tek kontakt for å gå gjennom førespurnaden. Ved behov avtaler vi synfaring, slik at vi har grunnlaget vi treng for å gi eit tilbod."],
  ["Vi avtaler tidspunkt og utfører arbeidet", "Du får avtalt tidspunkt før vi kjem. Oppdagar vi noko som påverkar pris eller omfang, avklarer vi det med deg før vi går vidare."],
  ["Du får dokumentasjonen", "Når arbeidet er ferdig, får du nødvendig dokumentasjon og samsvarserklæring der det er krav om det."],
];

/* ---------- Fixed-price services (private and small business). Example prices incl. VAT. ---------- */
export const PRICE_NOTE = "Prisane er døme. Vi avklarer omfang, prisgrunnlag og kva som er inkludert før arbeidet startar.";
export const PRICE_DEMO_LABEL = "Priseksempel";

export const PRICE_GROUPS = [
  {
    id: "lading",
    title: "Elbillading",
    text: "Heimeladar med lastbalansering, montert og dokumentert.",
    items: [
      { id: "heimeladar", name: "Heimeladar med montering", price: "Frå 14 900 kr", unit: "fastpris", label: "Fastpris", cta: "Be om pris på heimeladar", short: "Levering og montering av heimeladar ved standardinstallasjon. Vi avklarer kva som må gjerast i anlegget ditt før oppstart.", desc: "Ladar, inntil 10 m kabel, eigen kurs og jordfeilvern. Samsvarserklæring inkludert.", market: "service_bustad" },
      { id: "lading-sameige", name: "Ladeanlegg sameige og bedrift", price: "Etter befaring", unit: "gratis befaring", desc: "Infrastruktur, lastbalansering og betalingsløysing for parkeringsanlegg med fleire plassar.", market: "bygg_naering" },
    ],
  },
  {
    id: "sikringsskap",
    title: "Sikringsskap og el-kontroll",
    text: "Tryggleik for eldre anlegg. Ofte rabatt på forsikringa.",
    items: [
      { id: "sikringsskap", name: "Utskifting av sikringsskap", price: "Frå 24 900 kr", unit: "fastpris", label: "Fastpris", cta: "Be om pris på sikringsskap", short: "Utskifting av eksisterande sikringsskap ved standardinstallasjon. Vi vurderer anlegget og avklarer omfanget før du bestiller.", desc: "Automatsikringar, jordfeilbrytarar og overspenningsvern. Inntil 12 kursar. Samsvarserklæring og merking.", market: "service_bustad" },
      { id: "el-kontroll", name: "El-kontroll av bustad", price: "2 990 kr", unit: "fastpris", label: "Fastpris", cta: "Avtal el-kontroll", short: "Kontroll av sentrale delar av det elektriske anlegget. Vi avtaler kva kontrollen skal omfatte før besøket.", desc: "Gjennomgang av heile anlegget. Skriftleg rapport du kan bruke mot forsikringsselskapet.", market: "service_bustad" },
      { id: "komfyrvakt", name: "Komfyrvakt montert", price: "3 990 kr", unit: "fastpris", desc: "Godkjend komfyrvakt, montert og testa. Påbode i nye anlegg, lurt i alle.", market: "service_bustad" },
    ],
  },
  {
    id: "lys-varme",
    title: "Lys og varme",
    text: "Bad, kjøkken, stove og uterom.",
    items: [
      { id: "varmekablar", name: "Varmekablar på bad", price: "Frå 12 900 kr", unit: "inntil 6 m²", desc: "Varmekabel, termostat med app-styring og dokumentasjon. Legging koordinert med flisleggjar.", market: "service_bustad" },
      { id: "downlights", name: "Downlights, pakke på 6", price: "Frå 9 900 kr", unit: "fastpris", desc: "Dimbare LED-downlights med driver, ny kurs om nødvendig. Fleire pakkar gir lågare stykkpris.", market: "service_bustad" },
      { id: "utelys", name: "Utelys eller stikk ute", price: "Frå 2 490 kr", unit: "per punkt", desc: "Nytt utelys med skumringsrelé eller utvendig stikk med jordfeilvern.", market: "service_bustad" },
    ],
  },
  {
    id: "service",
    title: "Service og feilretting",
    text: "Når noko ikkje verkar.",
    items: [
      { id: "servicebesok", name: "Servicebesøk", price: "1 490 kr", unit: "første time, deretter 1 190 kr/t", label: "For første time", cta: "Send førespurnad om service", short: "Deretter 1 190 kr per time.", desc: "Elektrikar med utstyrt servicebil. Rapport på e-post etter besøket.", market: "service_bustad" },
      { id: "vakt", name: "Vakt utanom arbeidstid", price: "2 190 kr/t", unit: "pluss utrykking 1 900 kr", desc: "Feilretting utanom ordinær arbeidstid, etter avtale.", market: "service_bustad" },
      { id: "serviceavtale", name: "Serviceavtale bedrift", price: "Frå 990 kr/mnd", unit: "årleg kontroll", desc: "Årleg internkontroll av el-anlegget og fast kontaktperson. Butikk, verkstad og kontor.", market: "bygg_naering" },
    ],
  },
];

export const PRICES = PRICE_GROUPS.flatMap((g) => g.items.map((i) => ({ ...i, group: g.title })));

/* Highlights shown on the front page */
export const PRICE_HIGHLIGHTS = ["heimeladar", "sikringsskap", "el-kontroll", "servicebesok"];

export const MARKETS = {
  industri: {
    slug: "industri",
    key: "industri",
    title: "Industri",
    short: "Elektro og automasjon til prosessindustri, næring og oppdrett.",
    tagline: "Installasjon, automasjon og vedlikehald",
    desc: "Vi leverer elektro og automasjon til prosessindustri, oppdrett og andre industrianlegg. Vi installerer nye anlegg, byggjer om eksisterande installasjonar og utfører service og vedlikehald.",
    highlights: ["Kraft og fordeling", "Automasjon og styring", "Motorstyring og frekvensomformarar", "Installasjon og ombygging", "Service og vedlikehald"],
    cta: "Les meir om industri",
    lead: "Elektro og automasjon til industri og næring i distriktet. Vi har vore med på store oppdrag som utvidinga ved Boliden Odda og arbeid på Hydro Husnes, og tek både prosjekt og løpande vedlikehald.",
    hero: IMG.smelter,
    band: IMG.fish_farm,
    preview: IMG.steel,
    photo: IMG.svc_industri,
    focus: "50% 42%",
    detail: IMG.automation_hall,
    introTitle: "Store oppdrag, saman med fleire",
    intro: "Saman med samarbeidspartnarar har Kvinnherad Elektro signert storkontrakt på Boliden Odda-ekspansjonen og levert som underleverandør på Hydro Husnes. Med dotterselskapet Vassnes Solutions i Ølen og resten av EQVA-konsernet kan vi ta store, fleirfaglege prosjekt der elektro, automasjon og mekanisk heng saman.",
    services: [
      ["Kraft og fordeling", "Hovudfordelingar, transformatorar og nødstraum."],
      ["Automasjon og styring", "PLS, SCADA og styring av prosessutstyr."],
      ["Motorstyring og drives", "Frekvensomformarar, mjukstartarar og motorvern."],
      ["Vedlikehald og revisjon", "Planlagt vedlikehald og arbeid under revisjonsstans."],
      ["Oppdrett og marine anlegg", "Pumpestyring, alarm og nødstraum for anlegg ved fjorden."],
      ["Maritim og offshore", "Elektro og automasjon for fartøy og maritime anlegg."],
    ],
  },
  samferdsel: {
    slug: "samferdsel",
    key: "samferdsel",
    title: "Samferdsel",
    short: "Tunnelteknikk, styring og vegbelysning for Statens vegvesen og entreprenørar.",
    tagline: "Elektro til veg og tunnel",
    desc: "Vi utfører elektroinstallasjonar i samferdselsanlegg, med erfaring frå mellom anna Gudvanga- og Flenjatunnelane og Bømlafjordtunnelen.",
    highlights: ["Tunneltekniske installasjonar", "Styring og SRO", "Veg- og tunnelbelysning", "Kraftfordeling", "Service og vedlikehald"],
    cta: "Les meir om samferdsel",
    lead: "Tunnelteknikk, SRO og vegbelysning. Vi har oppgradert Gudvanga- og Flenjatunnelane for Statens vegvesen, i hovudsak som nattarbeid over fire år, og hatt kontraktar på Bømlafjordtunnelen og Bagnskleivtunnelen.",
    hero: IMG.tunnel_road,
    band: IMG.hardanger_bridge,
    preview: IMG.tunnel,
    photo: IMG.svc_samferdsel,
    focus: "50% 30%",
    detail: IMG.substation,
    introTitle: "Tunnelarbeid, mest om natta",
    intro: "Oppgraderinga av Gudvanga- og Flenjatunnelane tok fire år og fem månader og vart overlevert til Statens vegvesen hausten 2022. Før det kom kontrakten på elektro- og SRO-oppgradering av Bømlafjordtunnelen, og saman med Land Elektriske vann vi kontrakt på Bagnskleivtunnelen. Samferdsel krev planlegging, dokumentasjon og folk som er vane med korte nattstengingar.",
    services: [
      ["Tunnelteknikk", "Naudlys, leielys, ventilasjonsstyring og naudstasjonar."],
      ["Styring og SRO", "Styresystem for tunnel og veg."],
      ["Vegbelysning", "Oppgradering, styring og vedlikehald av veglys."],
      ["Kabling og føringsvegar", "Høg- og lågspent, fiber og føringsvegar."],
      ["Skiltproduksjon", "Skilt og merking til veg og anlegg."],
      ["Drift og vedlikehald", "Oppfølging av tekniske anlegg etter overlevering."],
    ],
  },
  "bygg-naering": {
    slug: "bygg-naering",
    key: "bygg_naering",
    title: "Bygg og næring",
    short: "Komplett elektroinstallasjon til næringsbygg, offentlege bygg og bustadprosjekt.",
    tagline: "Elektriske anlegg i nye og eksisterande bygg",
    desc: "Vi hjelper med prosjektering og installasjon når du skal byggje nytt, byggje om eller oppgradere eit næringsbygg. Arbeidet omfattar planlegging, utføring og dokumentasjon.",
    highlights: ["Elektroinstallasjon", "Brannalarm og naudlys", "Ladeanlegg", "Belysning", "Kraft og fordeling"],
    cta: "Les meir om bygg og næring",
    lead: "Komplett elektroinstallasjon til næringsbygg, offentlege bygg og bustadprosjekt, som Rosendal Bryggje, Husnes Seniorsenter og Nye Aksen på Husnes. Frå planlegging til gjennomføring og godkjenning av anlegget.",
    hero: IMG.electrician_woman,
    band: IMG.site_aerial,
    preview: IMG.wiring,
    photo: IMG.svc_bygg,
    focus: "50% 45%",
    detail: IMG.server_cables,
    introTitle: "Heile leveransen",
    intro: "Anten det gjeld nybygg, påbygg eller oppgradering av eksisterande anlegg, tek vi heile den elektrotekniske leveransen. Byggherre har éin kontakt, og anlegget blir dokumentert og godkjent før overlevering. Vi leverer òg internkontroll og årleg gjennomgang for bedrifter og offentlege bygg.",
    services: [
      ["Elektroinstallasjon", "Hovudtavler, fordelingar, kursopplegg og belysning."],
      ["Brannalarm og naudlys", "Installasjon og årleg kontroll."],
      ["Ladeanlegg", "Lading for sameige, næring og parkeringsanlegg."],
      ["Solceller", "Solcelleanlegg for bustad og næring."],
      ["Tele og data", "Strukturert kabling, fiber og adgangskontroll."],
      ["Internkontroll", "Internkontroll og årleg gjennomgang av el-anlegget for bedrifter."],
    ],
  },
  "service-bustad": {
    slug: "service-bustad",
    key: "service_bustad",
    title: "Service og bustad",
    short: "Feilretting, elbillading, nytt sikringsskap og el-sjekk for heim, hytte og mindre bedrifter.",
    tagline: "Elektrikar til jobben du skal ha gjort",
    desc: "Vi hjelper med feilretting, kontroll og nye installasjonar heime. Det kan vere ein heimeladar, eit nytt sikringsskap eller det elektriske arbeidet ved ei oppussing.",
    highlights: ["Feilretting og service", "Elbillading", "Sikringsskap", "Oppussing og rehabilitering", "El-kontroll"],
    cta: "Les meir om service og bustad",
    lead: "Elektrikaren du ringjer når noko ikkje verkar heime, på hytta eller i butikken. Service-elektrikarar med lang erfaring og velutstyrte servicebilar, frå Rosendal, Husnes og Halsnøy.",
    hero: IMG.breaker_panel,
    band: IMG.ev_garage,
    preview: IMG.electrician_cabinet,
    photo: IMG.svc_service,
    photoAlt: "Ein elektrikar og to kundar ved eit ope sikringsskap.",
    focus: "50% 26%",
    detail: IMG.technician_portrait,
    introTitle: "Service-elektrikarar med erfaring",
    intro: "Service-elektrikarane våre har lang erfaring frå servicearbeid og velutstyrte servicebilar. Vi tilbyr el-sjekk, internkontroll for bedrifter og årleg gjennomgang av det elektriske anlegget, for private og offentlege. Dei vanlegaste jobbane kan du sjå døme på prisar for under.",
    services: [
      ["Feilretting og service", "Sikringar som går, varmekablar, lys og stikk."],
      ["Elbillading", "Heimeladar og oppgradering av sikringsskap."],
      ["Nytt sikringsskap", "Oppgradering av eldre anlegg med jordfeilautomatar og overspenningsvern."],
      ["Bad og kjøkken", "Varmekablar, belysning og nye kursar ved rehabilitering."],
      ["El-sjekk", "Gjennomgang av anlegget med rapport."],
      ["Mindre bedriftsoppdrag", "Butikk, verkstad og kontor. Internkontroll og serviceavtale."],
    ],
    showPrices: true,
  },
};

export const MARKET_ORDER = ["industri", "samferdsel", "bygg-naering", "service-bustad"];

/* Contact persons as published on kvinnheradelektro.no/kontakt-oss */
export const PEOPLE = [
  { name: "Kjetil Helvik", title: "Dagleg leiar og økonomisjef", phone: "95 83 19 80", email: "kjetil@k-el.no" },
  { name: "Morten Gravdal", title: "Installatør", phone: "917 30 100", email: "morten@k-el.no" },
  { name: "Espen Handeland", title: "Saksbehandlar Rosendal", phone: "99 30 34 59", email: "espen@k-el.no" },
  { name: "Steinar Mælen", title: "Ingeniør maritim/offshore", phone: "48 99 01 40", email: "steinar@k-el.no" },
  { name: "Jonas Hølland", title: "Prosjektleiar samferdsel, solceller og HMS-ansvarleg", phone: "91 73 13 95", email: "jonas@k-el.no" },
  { name: "Per Fjelland", title: "Næring, bustad og service Husnes og Halsnøy", phone: "91 51 52 05", email: "ptf@k-el.no" },
  { name: "Kim Raudstein", title: "Lageransvarleg", phone: "97 06 71 03", email: "kim@k-el.no" },
];

/* Milestones from kvinnheradelektro.no/nyhende and EQVA ASA */
export const TIMELINE = [
  { year: "80+ år", title: "Starten i Rosendal", text: "Kvinnherad Elektro har levert elektrotenester til marknaden i over 80 år, med hovudkontor i Rosendal." },
  { year: "2015", title: "Vassnes Solutions", text: "Kjøper 51 % av Vassnes Solutions AS i Ølen og kan ta større oppdrag saman." },
  { year: "2016–2022", title: "Tunnelkontraktar", text: "Elektro- og SRO-oppgradering av Bømlafjordtunnelen, og Gudvanga- og Flenjatunnelane for Statens vegvesen, overlevert hausten 2022." },
  { year: "2023", title: "Boliden Odda", text: "Storkontrakt på Boliden Odda-ekspansjonen saman med NLI Elektrosystemer." },
  { year: "2024", title: "Del av EQVA", text: "EQVA ASA kjøper Kvinnherad Elektro. Same namn, same leiing og same folk." },
];

/* Application paths, not open positions. */
export const APPLY = [
  { title: "Elektrikar", text: "Service, bustad, næringsbygg, tunnel og industri. Fagbrev som elektrikar." },
  { title: "Automatikar eller ingeniør", text: "Styring, SRO og automasjon på industri- og samferdselsanlegg." },
  { title: "Lærling", text: "Vi er godkjend lærebedrift i elektrikarfaget." },
];

/* Assignments the company has announced publicly on kvinnheradelektro.no */
export const MENTIONED_WORK = ["Gudvanga- og Flenjatunnelane", "Bømlafjordtunnelen", "Boliden Odda", "Hydro Husnes", "Rosendal Bryggje", "Husnes Seniorsenter", "Nye Aksen Husnes"];
